import { Actions, Subjects } from '@/client/users';
import {
  DashboardType,
  LAST_SELECTED_DASHBOARD,
  RedirectPaths,
  RedirectPathsEnum,
} from '@/common/constants';
import { REDIRECT_URL_KEY } from '@/common/constants/user';
import { usePermission } from '@/hooks/usePermission';
import { removeParamsFromPath } from '@/utils/url';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const appendQueryParams = (
  baseUrl: string,
  redirectUrl: string | null,
): string => {
  return (
    baseUrl + (redirectUrl?.startsWith('/?') ? redirectUrl.substring(1) : '')
  );
};

export const Redirect = () => {
  const navigate = useNavigate();
  const { can } = usePermission();

  let redirectUrl = sessionStorage.getItem(REDIRECT_URL_KEY);

  const deployPath = process.env.REACT_APP_PREVIEW_DEPLOY_PATH;

  if (redirectUrl && deployPath) {
    redirectUrl = redirectUrl?.replace(deployPath, '');

    // (e.g. '/dev-2440/domain-verification/token' → '//domain-verification/token').
    if (redirectUrl?.startsWith('//')) {
      redirectUrl = redirectUrl.slice(1);
    }
  }

  useEffect(() => {
    if (!redirectUrl) {
      return;
    }

    sessionStorage.removeItem(REDIRECT_URL_KEY);
  }, [redirectUrl]);

  useEffect(() => {
    // Set the initial dashboard style
    if (
      (!localStorage.getItem(LAST_SELECTED_DASHBOARD) &&
        can(Actions.READ, Subjects.ADMIN_DASHBOARD)) ||
      (localStorage.getItem(LAST_SELECTED_DASHBOARD) === DashboardType.ADMIN &&
        can(Actions.READ, Subjects.ADMIN_DASHBOARD))
    ) {
      const parsedRedirectUrl = removeParamsFromPath(redirectUrl, [
        'login_hint',
        'ui_locales',
      ]);

      navigate(
        parsedRedirectUrl &&
          parsedRedirectUrl.replace('/', '') !== '' &&
          !parsedRedirectUrl.startsWith('/?')
          ? parsedRedirectUrl
          : appendQueryParams(
              RedirectPaths[RedirectPathsEnum.ADMIN_DASHBOARD](),
              redirectUrl,
            ),
      );

      return;
    }

    const canAccess = redirectUrl?.match(/dashboard\/learner|courses/);
    navigate(
      redirectUrl &&
        redirectUrl.replace('/', '') !== '' &&
        canAccess &&
        !redirectUrl.startsWith('/?')
        ? redirectUrl
        : appendQueryParams(
            RedirectPaths[RedirectPathsEnum.LEARNER_DASHBOARD_ACTIVE](),
            redirectUrl,
          ),
    );
  }, []);

  return <Outlet />;
};
